import { h, Host } from "@stencil/core";
import { translate } from "../../service/translation-service";
const regExp = /^.*(vimeo\.com\/)((video\/)|(channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
export class VimeoVideo {
    constructor() {
        this.autoplay = false;
        this.visible = true;
        this.hasConsent = false;
    }
    onSrcChanged() {
        const match = (this.src || '').match(regExp);
        this.id = (match && match[6].length) ? match[6] : '';
    }
    onUcEvent(event) {
        this.hasConsent = event.detail['Vimeo'];
    }
    consentChanged(event) {
        this.hasConsent = event.detail.vimeo;
    }
    async componentWillLoad() {
        this.onSrcChanged();
        this.hasConsent = this.getCurrentConsent();
        this.visible = false;
        this.observer = new IntersectionObserver((entries, observer) => {
            entries
                .filter(entry => entry.isIntersecting)
                .forEach(entry => {
                this.visible = true;
                observer.unobserve(entry.target);
            });
        }, { rootMargin: '100px 0px 100px 0px' });
        this.observer.observe(this.el);
    }
    getCurrentConsent() {
        var _a, _b;
        if (window['UC_UI'] !== undefined) {
            return (_a = UC_UI.getServicesBaseInfo().filter(info => info.id === 'HyEX5Nidi-m')[0]) === null || _a === void 0 ? void 0 : _a.consent.status;
        }
        return ((_b = window['uvexConsentManager']) === null || _b === void 0 ? void 0 : _b.isVimeoEnabled) || false;
    }
    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.visibilityObserver) {
            this.visibilityObserver.disconnect();
        }
    }
    confirmConsent(event) {
        // Prevent confirmation when clicking a link of the consent text
        if (event.target.tagName.toLowerCase() === 'a') {
            return;
        }
        if (typeof UC_UI !== 'undefined') {
            // Usercentrics
            UC_UI === null || UC_UI === void 0 ? void 0 : UC_UI.acceptService('HyEX5Nidi-m');
        }
        // Uvex Consent Manager
        const consentManager = window['uvexConsentManager'];
        consentManager === null || consentManager === void 0 ? void 0 : consentManager.updateConsentSettings(Object.assign(consentManager.consentSettings, { vimeo: true }));
    }
    render() {
        var _a, _b;
        if (!this.hasConsent) {
            let picture;
            if ('uvexStyleGuide' in window && ((_b = (_a = window['uvexStyleGuide']) === null || _a === void 0 ? void 0 : _a.proxy) === null || _b === void 0 ? void 0 : _b.vimeo) !== '') {
                const src = window.uvexStyleGuide.proxy.vimeo.replace(/%[sd]/, this.id);
                picture = h("picture", { class: "embed-responsive-item", style: { '--aspect-ratio': '1,77777778', '--width': '1110px' } }, h("img", { loading: "lazy", class: "img-fluid", src: src, width: "1110", height: "625", alt: "" }));
            }
            return h(Host, { class: "embed-responsive embed-responsive-16by9 consent-mode" }, picture, h("div", { class: "embed-responsive-item consent-layer", onClick: event => this.confirmConsent(event) }, h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", fill: "#fff", width: "32", height: "32" }, h("path", { d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" })), h("span", { innerHTML: translate('vimeo.consent') })));
        }
        const props = {
            onload: () => {
            },
            allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
            allowfullscreen: '',
            frameborder: '0',
            id: '',
            src: '',
            webkitallowfullscreen: '',
            mozallowfullscreen: ''
        };
        if (this.visible && this.id) {
            props.onload = () => this.loaded.emit({ id: this.id });
            props.id = `player-${this.id}`;
            props.src = `https://player.vimeo.com/video/${this.id}?autoplay=1${this.autoplay ? '&background=1' : ''}`;
        }
        return h(Host, { class: "embed-responsive embed-responsive-16by9" }, h("iframe", Object.assign({ ref: el => this.iframeVideo = el, width: "560", height: "315", frameborder: "0" }, props)));
    }
    static get is() { return "uvex-vimeo-video"; }
    static get originalStyleUrls() {
        return {
            "$": ["./vimeo-video.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vimeo-video.css"]
        };
    }
    static get properties() {
        return {
            "src": {
                "type": "string",
                "attribute": "src",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "autoplay": {
                "type": "boolean",
                "attribute": "autoplay",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "id": {},
            "visible": {},
            "hasConsent": {}
        };
    }
    static get events() {
        return [{
                "method": "loaded",
                "name": "vimeo-video-loaded",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "src",
                "methodName": "onSrcChanged"
            }];
    }
    static get listeners() {
        return [{
                "name": "ucEvent",
                "method": "onUcEvent",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "uvexConsentChanged",
                "method": "consentChanged",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=vimeo-video.js.map
